export default {
    path: 'activity',
    meta: {
      title: '促销管理'
    },
    component: () => import('@/components/parent-view'),
    name: 'pam',
    children: [
      {
        path: 'statistical',
        meta: {
          title: '活动统计'
        },
        component: () => import('@/components/parent-view'),
        children: [
          {
            path: 'list',
            meta: {
              title: '活动数据列表',
              ignoreBreadCrumb: true,
              notCache: true
            },
            name: 'pam-statistical',
            component: () => import('@/view/pam/statistical/index')
          },
          {
            path: 'detail',
            meta: {
              title: '活动明细查询',
              ignoreBreadCrumb: true,
              notCache: true
            },
            name: 'pam-statistical',
            component: () => import('@/view/pam/statistical/detail')
          },
          {
            path: 'applyList',
            meta: {
              title: '活动报名查询',
              ignoreBreadCrumb: true,
              notCache: true
            },
            name: 'pam-statistical',
            component: () => import('@/view/pam/statistical/applyList')
          },
          {
            path: 'personal',
            meta: {
              title: '个人明细查询',
              ignoreBreadCrumb: true,
              notCache: true
            },
            name: 'pam-statistical',
            component: () => import('@/view/pam/statistical/personal')
          }
        ]
      },
      {
        path: 'manage',
        meta: {
          title: '活动管理'
        },
        component: () => import('@/components/parent-view'),
        children: [
          {
            path: 'list',
            meta: {
              title: '活动管理列表',
              ignoreBreadCrumb: true
            },
            name: 'pam-manage-index',
            component: () => import('@/view/pam/manage/index')
          },
          {
            path: 'add',
            meta: {
              title: '添加活动',
              ignoreBreadCrumb: true
            },
            name: 'pam-manage-add',
            component: () => import('@/view/pam/manage/edit')
          },
          {
            path: 'edit',
            meta: {
              title: '编辑活动',
              ignoreBreadCrumb: true
            },
            name: 'pam-manage-edit',
            component: () => import('@/view/pam/manage/edit')
          },
          {
            path: 'detail',
            meta: {
              title: '活动详情',
              ignoreBreadCrumb: true
            },
            name: 'pam-manage-detail',
            component: () => import('@/view/pam/manage/detail')
          }
        ]
      }
    ]
}


// WEBPACK FOOTER //
// ./src/router/routes/pam.js